import React, { useMemo } from "react";
import { useUserDataContext } from "@/store/UserProvider";
import { useSubscriptionStore } from "@/store/useSubscriptionStore";
import { useLocation } from "react-router-dom";
import { NotRegisteredModal } from "./NotRegisteredModal";
import RegisteredModal from "./RegisteredModal";

export default function WelcomeModal() {
  const { user } = useUserDataContext();
  const { search } = useLocation();
  const { isSubscriptionActive } = useSubscriptionStore();

  const isPaymentConfirmed = useMemo(() => {
    return (
      new URLSearchParams(search).get("tgWebAppStartParam") ===
      "payment_confirmed_true"
    );
  }, [search]);

  if (isPaymentConfirmed && isSubscriptionActive) return null;

  if (!user?.dc_person_id && !isSubscriptionActive)
    return <NotRegisteredModal />;

  return <RegisteredModal />;
}
